import { React } from "./react-with-context";
import Auth, { AuthUser } from "../../services/Auth";
import ApolloClient from "apollo-client";

const UserContext = React.createContext<AuthUser | null>(null);
const AuthContext = React.createContext<Auth>(new Auth());

export interface Props {
  children?: React.ReactNode;
  service?: Auth;
  apollo?: ApolloClient<{}>;
}

export interface State {
  user: AuthUser | null;
}

export default class AuthProvider extends React.Component<Props, State> {
  userService: Auth;
  constructor(props: Props) {
    super(props);
    this.userService = props.service || new Auth();
    this.userService.onUserChange = newUser => this.setUser(newUser);
    this.state = { user: this.userService.getUser() };
  }
  setUser = (newUser: AuthUser | null) => {
    this.setState(
      ({ user }) => ({
        user: newUser
      }),
      () => {
        if (this.props.apollo) {
          this.props.apollo.resetStore();
        }
      }
    );
  };
  render() {
    return (
      <AuthContext.Provider value={this.userService}>
        <UserContext.Provider value={this.state.user}>
          {this.props.children}
        </UserContext.Provider>
      </AuthContext.Provider>
    );
  }
}
// only doing this to shield end-users from the
// implementation detail of "context"
const AuthConsumer = AuthContext.Consumer;
const UserConsumer = UserContext.Consumer;

export { AuthConsumer, UserConsumer, AuthProvider };



// WEBPACK FOOTER //
// ./src/components/AuthProvider/AuthProvider.tsx